/* src/components/AboutPortrait/AboutPortrait.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	append_hydration,
	attr,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert_hydration,
	mount_component,
	safe_not_equal,
	set_data,
	space,
	src_url_equal,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import Modal from '../Modal/Modal.svelte';

function create_if_block(ctx) {
	let modal;
	let current;

	modal = new Modal({
			props: {
				title: /*member*/ ctx[0].first_name + ' ' + /*member*/ ctx[0].last_name,
				width: "850px",
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	modal.$on("modal-close", /*handleClose*/ ctx[2]);

	return {
		c() {
			create_component(modal.$$.fragment);
		},
		l(nodes) {
			claim_component(modal.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(modal, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const modal_changes = {};
			if (dirty & /*member*/ 1) modal_changes.title = /*member*/ ctx[0].first_name + ' ' + /*member*/ ctx[0].last_name;

			if (dirty & /*$$scope, member*/ 17) {
				modal_changes.$$scope = { dirty, ctx };
			}

			modal.$set(modal_changes);
		},
		i(local) {
			if (current) return;
			transition_in(modal.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(modal.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(modal, detaching);
		}
	};
}

// (28:2) <Modal on:modal-close={handleClose} title={member.first_name + ' ' + member.last_name} width="850px">
function create_default_slot(ctx) {
	let div1;
	let figure;
	let img;
	let img_src_value;
	let img_alt_value;
	let t0;
	let div0;
	let p0;
	let t1_value = /*member*/ ctx[0].first_name + "";
	let t1;
	let t2;
	let t3_value = /*member*/ ctx[0].last_name + "";
	let t3;
	let t4;
	let p1;
	let t5_value = /*member*/ ctx[0].title + "";
	let t5;
	let t6;
	let p2;
	let t7_value = /*member*/ ctx[0].bio + "";
	let t7;

	return {
		c() {
			div1 = element("div");
			figure = element("figure");
			img = element("img");
			t0 = space();
			div0 = element("div");
			p0 = element("p");
			t1 = text(t1_value);
			t2 = space();
			t3 = text(t3_value);
			t4 = space();
			p1 = element("p");
			t5 = text(t5_value);
			t6 = space();
			p2 = element("p");
			t7 = text(t7_value);
			this.h();
		},
		l(nodes) {
			div1 = claim_element(nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			figure = claim_element(div1_nodes, "FIGURE", { class: true });
			var figure_nodes = children(figure);
			img = claim_element(figure_nodes, "IMG", { src: true, alt: true, class: true });
			figure_nodes.forEach(detach);
			t0 = claim_space(div1_nodes);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			p0 = claim_element(div0_nodes, "P", { class: true });
			var p0_nodes = children(p0);
			t1 = claim_text(p0_nodes, t1_value);
			t2 = claim_space(p0_nodes);
			t3 = claim_text(p0_nodes, t3_value);
			p0_nodes.forEach(detach);
			t4 = claim_space(div0_nodes);
			p1 = claim_element(div0_nodes, "P", { class: true });
			var p1_nodes = children(p1);
			t5 = claim_text(p1_nodes, t5_value);
			p1_nodes.forEach(detach);
			t6 = claim_space(div0_nodes);
			p2 = claim_element(div0_nodes, "P", {});
			var p2_nodes = children(p2);
			t7 = claim_text(p2_nodes, t7_value);
			p2_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (!src_url_equal(img.src, img_src_value = /*member*/ ctx[0].largest.cache)) attr(img, "src", img_src_value);
			attr(img, "alt", img_alt_value = /*member*/ ctx[0].first_name + ' ' + /*member*/ ctx[0].last_name);
			attr(img, "class", "svelte-1qbfmxi");
			attr(figure, "class", "team-modal__avatar svelte-1qbfmxi");
			attr(p0, "class", "team-modal__name svelte-1qbfmxi");
			attr(p1, "class", "team-modal__role svelte-1qbfmxi");
			attr(div0, "class", "team-modal__content");
			attr(div1, "class", "team-modal modal-body svelte-1qbfmxi");
		},
		m(target, anchor) {
			insert_hydration(target, div1, anchor);
			append_hydration(div1, figure);
			append_hydration(figure, img);
			append_hydration(div1, t0);
			append_hydration(div1, div0);
			append_hydration(div0, p0);
			append_hydration(p0, t1);
			append_hydration(p0, t2);
			append_hydration(p0, t3);
			append_hydration(div0, t4);
			append_hydration(div0, p1);
			append_hydration(p1, t5);
			append_hydration(div0, t6);
			append_hydration(div0, p2);
			append_hydration(p2, t7);
		},
		p(ctx, dirty) {
			if (dirty & /*member*/ 1 && !src_url_equal(img.src, img_src_value = /*member*/ ctx[0].largest.cache)) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*member*/ 1 && img_alt_value !== (img_alt_value = /*member*/ ctx[0].first_name + ' ' + /*member*/ ctx[0].last_name)) {
				attr(img, "alt", img_alt_value);
			}

			if (dirty & /*member*/ 1 && t1_value !== (t1_value = /*member*/ ctx[0].first_name + "")) set_data(t1, t1_value);
			if (dirty & /*member*/ 1 && t3_value !== (t3_value = /*member*/ ctx[0].last_name + "")) set_data(t3, t3_value);
			if (dirty & /*member*/ 1 && t5_value !== (t5_value = /*member*/ ctx[0].title + "")) set_data(t5, t5_value);
			if (dirty & /*member*/ 1 && t7_value !== (t7_value = /*member*/ ctx[0].bio + "")) set_data(t7, t7_value);
		},
		d(detaching) {
			if (detaching) detach(div1);
		}
	};
}

function create_fragment(ctx) {
	let div1;
	let img;
	let img_alt_value;
	let img_src_value;
	let t0;
	let div0;
	let p0;
	let t1_value = /*member*/ ctx[0].first_name + "";
	let t1;
	let t2;
	let t3_value = /*member*/ ctx[0].last_name + "";
	let t3;
	let t4;
	let p1;
	let t5_value = /*member*/ ctx[0].title + "";
	let t5;
	let t6;
	let if_block_anchor;
	let current;
	let if_block = /*showModal*/ ctx[1] && create_if_block(ctx);

	return {
		c() {
			div1 = element("div");
			img = element("img");
			t0 = space();
			div0 = element("div");
			p0 = element("p");
			t1 = text(t1_value);
			t2 = space();
			t3 = text(t3_value);
			t4 = space();
			p1 = element("p");
			t5 = text(t5_value);
			t6 = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
			this.h();
		},
		l(nodes) {
			div1 = claim_element(nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			img = claim_element(div1_nodes, "IMG", { class: true, alt: true, src: true });
			t0 = claim_space(div1_nodes);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			p0 = claim_element(div0_nodes, "P", { class: true });
			var p0_nodes = children(p0);
			t1 = claim_text(p0_nodes, t1_value);
			t2 = claim_space(p0_nodes);
			t3 = claim_text(p0_nodes, t3_value);
			p0_nodes.forEach(detach);
			t4 = claim_space(div0_nodes);
			p1 = claim_element(div0_nodes, "P", { class: true });
			var p1_nodes = children(p1);
			t5 = claim_text(p1_nodes, t5_value);
			p1_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			t6 = claim_space(nodes);
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
			this.h();
		},
		h() {
			attr(img, "class", "team-member__photo svelte-1qbfmxi");
			attr(img, "alt", img_alt_value = /*member*/ ctx[0].first_name + ' ' + /*member*/ ctx[0].last_name);
			if (!src_url_equal(img.src, img_src_value = /*member*/ ctx[0].largest.cache)) attr(img, "src", img_src_value);
			attr(p0, "class", "team-member__name svelte-1qbfmxi");
			attr(p1, "class", "team-member__role svelte-1qbfmxi");
			attr(div0, "class", "team-member__details svelte-1qbfmxi");
			attr(div1, "class", "team-col team-member svelte-1qbfmxi");
		},
		m(target, anchor) {
			insert_hydration(target, div1, anchor);
			append_hydration(div1, img);
			append_hydration(div1, t0);
			append_hydration(div1, div0);
			append_hydration(div0, p0);
			append_hydration(p0, t1);
			append_hydration(p0, t2);
			append_hydration(p0, t3);
			append_hydration(div0, t4);
			append_hydration(div0, p1);
			append_hydration(p1, t5);
			insert_hydration(target, t6, anchor);
			if (if_block) if_block.m(target, anchor);
			insert_hydration(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (!current || dirty & /*member*/ 1 && img_alt_value !== (img_alt_value = /*member*/ ctx[0].first_name + ' ' + /*member*/ ctx[0].last_name)) {
				attr(img, "alt", img_alt_value);
			}

			if (!current || dirty & /*member*/ 1 && !src_url_equal(img.src, img_src_value = /*member*/ ctx[0].largest.cache)) {
				attr(img, "src", img_src_value);
			}

			if ((!current || dirty & /*member*/ 1) && t1_value !== (t1_value = /*member*/ ctx[0].first_name + "")) set_data(t1, t1_value);
			if ((!current || dirty & /*member*/ 1) && t3_value !== (t3_value = /*member*/ ctx[0].last_name + "")) set_data(t3, t3_value);
			if ((!current || dirty & /*member*/ 1) && t5_value !== (t5_value = /*member*/ ctx[0].title + "")) set_data(t5, t5_value);

			if (/*showModal*/ ctx[1]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*showModal*/ 2) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			if (detaching) detach(t6);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { member = {} } = $$props;
	let showModal = false;

	const handleClick = () => {
		$$invalidate(1, showModal = true);
	};

	const handleClose = () => {
		$$invalidate(1, showModal = false);
	};

	$$self.$$set = $$props => {
		if ('member' in $$props) $$invalidate(0, member = $$props.member);
	};

	return [member, showModal, handleClose];
}

class AboutPortrait extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { member: 0 });
	}
}

export default AboutPortrait;